import React from 'react'
import { connect } from 'react-redux'
import {Button, Col, Divider, Form, Input, message, Spin, Tag, Row, Typography, Space, Cascader, Select} from 'antd'
import { ContactsOutlined, FileAddOutlined, EditOutlined } from '@ant-design/icons'

import '../../asset/less/NewPieces.css'
import { getArtistContact, patchArtistContact, postArtistContact } from '../../api/artistPartnerProfile'
import HttpError from '../../component/base/HttpError'
import FormButton from '../../component/base/FormButton'
import StateDropdown from '../../component/contact/StateDropdown'
import { withRouter } from 'react-router'
import { URL_CONTACTS } from '../../const'
import {getPageId,stringToColor} from "../../component/Utils";
import {is_admin_user} from "../../app/role";
import {getFullNameByArtist} from "../../app/util";
import {RequiredTitle} from "../../component/piece/common";

const { Title, Text } = Typography
const { TextArea } = Input

@connect((state) => ({
    id: state.user.info.id, // real user id, admin_id or artist_id
    userId: state.user.info.userId, // artist user obj id
    artistId: state.user.info.artistId, // artist obj id
    artistName: state.user.info.artistName,
    email: state.user.info.email,
    role: state.user.info.role,
    artists: state.artist.artistNames
}))

class NewContact extends React.Component {
    constructor(props) {
        super(props)
        this.formRef = React.createRef()
        this.state = {
            loading: false,
            tags: [],
            sources: [],
            inputValue: '',
            sourceValue: '',
            stateVal: '',
            contacts: [],
        }
        this.is_new = props.new
    }

    getContactId = () => {
        return getPageId(this.props)
    }

    componentDidMount() {
        this.setState({
            loading: true
        })
        if (!this.is_new) {
            getArtistContact(this.getContactId())
                .then((r) => {
                    let i;
                    let arr;
                    let splt;
                    if (this.formRef.current) {
                        let data = r.data
                        // handle sources and tags here for loading
                        const tagsStr = data.tags;
                        const sourceStr = data.source;

                        this.setState({
                            stateVal: data.state
                        })

                        if (tagsStr && tagsStr.length > 4) {
                            splt = tagsStr.substring(2, tagsStr.length - 2);
                            arr = splt.split("','");

                            this.setState({
                                tags: arr
                            })

                            splt = arr[0]
                            for (i = 1; i < arr.length; i++) {
                                splt += ", " + arr[i]
                            }
                            data.tags = splt
                        }

                        if (sourceStr && sourceStr.length > 4) {
                            splt = sourceStr.substring(2, sourceStr.length - 2);
                            arr = splt.split("','");

                            this.setState({
                                sources: arr
                            })

                            splt = arr[0]
                            for (i = 1; i < arr.length; i++) {
                                splt += ", " + arr[i]
                            }
                            data.source = splt
                        }

                        this.formRef.current.setFieldsValue(data)
                    }
                })
                .catch((error) => {
                    HttpError(error)
                })
                .finally((v) => {
                    this.setState({
                        loading: false
                    })
                })
        } else {
            this.setState({
                loading: false
            })
        }
    }

    onFinish = (values) => {
        let i;
        this.setState({
            loading: true
        })
        if (this.props.artistId) {
            values['artist'] = this.props.artistId
        }

        let str = values.tags;
        let tagArr = [];
        if (values) {
            tagArr = this.state.tags
            str = "["
            for (i = 0; i < tagArr.length; i++) {
                if (i !== tagArr.length - 1)
                    str += "'" + tagArr[i] + "',"
                else
                    str += "'" + tagArr[i] + "']"
            }
            if (tagArr.length === 0) {
                values.tags = null
            }
            else {
                values.tags = str
            }    
        }

        if (values.state) {
            values.state = this.state.stateVal
        }

        str = values.source
        tagArr = []
        if (values) {
            tagArr = this.state.sources
            str = "["
            for (i = 0; i < tagArr.length; i++) {
                if (i !== tagArr.length - 1)
                    str += "'" + tagArr[i] + "',"
                else
                    str += "'" + tagArr[i] + "']"
            }
            if (tagArr.length === 0) {
                values.source = null
            }
            else {
                values.source = str
            }
        }

        //if (str && str.length > 0) {
            //tagArr = str.split(/ *, */)
            //str = "["
            //for (var i = 0; i < tagArr.length; i++) {
                //if (i != tagArr.length - 1)
                    //str += "'" + tagArr[i] + "',"
                //else
                    //str += "'" + tagArr[i] + "']"
            //}
            //values.source = str
        //}

        if (this.is_new) {
            postArtistContact(values)
                .then((res) => {
                    message.success('Added contact successfully').then((r) => { })
                    this.props.history.push(URL_CONTACTS)
                })
                .catch((error) => {
                    HttpError(error)
                })
                .finally(() => {
                    this.setState({
                        loading: false
                    })
                })
        } else {
            patchArtistContact(this.getContactId(), values)
                .then((res) => {
                    message.success('Updated contact successfully').then((r) => {})
                })
                .catch((error) => {
                    HttpError(error)
                })
                .finally(() => {
                    this.setState({
                        loading: false
                    })
                })
        }
    }

    onFinishFailed = ({ values, errorFields, outOfDate }) => {
        this.setState({ validateError: errorFields })
        window.scrollTo(0, 0)
        window.scrollTop = 0
    }

    handleClose = (removedTag) => {
        const newTags = this.state.tags.filter((tag) => tag !== removedTag)
        this.setState({
            tags: newTags
        })
    }

    handleInputChange = (e) => {
        this.setState({
            inputValue: e.target.value
        })
    }

    handleInputConfirm = (e) => {
        e.preventDefault()
        if (this.state.inputValue && this.state.tags.indexOf(this.state.inputValue) === -1) {
            this.setState({
                tags: [...this.state.tags, this.state.inputValue]
            })
        }
        this.setState({
            inputValue: ''
        })
    }

    sourceHandleClose = (removedSource) => {
        const newSources = this.state.sources.filter((source) => source != removedSource)
        this.setState({
            sources: newSources
        })
    }

    sourceHandleInputChange = (e) => {
        this.setState({
            sourceValue: e.target.value
        })
    }

    sourceHandleInputConfirm = (e) => {
        e.preventDefault()
        if (this.state.sourceValue && this.state.sources.indexOf(this.state.sourceValue) === -1) {
            this.setState({
                sources: [...this.state.sources, this.state.sourceValue]
            })
        }
        this.setState({
            sourceValue: ''
        })
    }

    loadTags = () => {
        const tagArr = [];
        for (let i = 0; i < this.state.tags.length; i++) {
            const str = this.state.tags[i]
            tagArr.push(
                <Tag
                    closable
                    color={stringToColor(str)}
                    onClose={(e) => {
                        e.preventDefault()
                        this.handleClose(str)
                    }}
                >
                    {str}
                </Tag>
            )
        }
        return tagArr
    }

    loadSources = () => {
        const sourceArr = [];
        for (let i = 0; i < this.state.sources.length; i++) {
            const str = this.state.sources[i]
            sourceArr.push(
                <Tag
                    closable
                    onClose={(e) => {
                        e.preventDefault()
                        this.sourceHandleClose(str)
                    }}
                >
                    {str}
                </Tag>
            )
        }
        return sourceArr
    }
    render() {
        const formStyle = {
            maxWidth: '80vw'
        }

        return (
            <Spin size='large' spinning={this.state.loading}>
                <Row align='bottom' gutter={{ xs: 8, sm: 16, md: 24 }}>
                    <Col>
                        <Title level={2} style={{ marginBottom: 0 }}>
                            {this.is_new === true ? <FileAddOutlined /> : <EditOutlined />}
                            {this.is_new === true ? ' New' : ' Edit'} Contact
                        </Title>
                    </Col>
                </Row>
                <Divider orientation='left'/>
                <Form
                    labelCol={{ span: 4 }}
                    wrapperCol={{ span: 14, offset: 2 }}
                    colon={false}
                    ref={this.formRef}
                    onFinish={this.onFinish}
                    onFinishFailed={this.onFinishFailed}
                >
                    {is_admin_user(this.props) && !this.props.artistId && (
                        <>
                            <Form.Item name='artist' label={RequiredTitle('Artist')} rules={[{required: true}]}>
                                <Select
                                    style={formStyle}
                                    showSearch
                                    optionFilterProp='label'
                                    placeholder='Please select artist'
                                    options={this.props.artists?.map((artist) => ({
                                        value: artist.artist_id,
                                        label: artist.name
                                    }))}
                                    disabled={!this.props.new}
                                />
                            </Form.Item>
                            <Divider orientation='left'/>
                        </>
                    )}
                    <Form.Item
                        name='first_name'
                        label='First Name'
                        style={formStyle}
                        rules={[
                            {
                                required: true,
                                type: 'string',
                                max: 100,
                                min: 1
                            }
                        ]}
                    >
                        <Input  />
                    </Form.Item>
                    <Form.Item
                        style={formStyle}
                        name='middle_name'
                        label='Middle Name'
                        rules={[
                            {
                                required: false,
                                type: 'string',
                                max: 100,
                                min: 1
                            }
                        ]}
                    >
                        <Input />
                    </Form.Item>
                    <Form.Item
                        style={formStyle}
                        name='last_name'
                        label='Last Name'
                        rules={[
                            {
                                required: true,
                                type: 'string',
                                max: 100,
                                min: 1
                            }
                        ]}
                    >
                        <Input />
                    </Form.Item>
                    <Divider orientation='left'/>
                    <Form.Item
                        style={formStyle}
                        name='job_title'
                        label='Job Title'
                        rules={[
                            {
                                required: false,
                                type: 'string',
                                max: 100,
                                min: 1
                            }
                        ]}
                    >
                        <Input />
                    </Form.Item>
                    <Form.Item
                        style={formStyle}
                        name='company'
                        label='Company'
                        rules={[
                            {
                                required: false,
                                type: 'string',
                                max: 100,
                                min: 1
                            }
                        ]}
                    >
                        <Input />
                    </Form.Item>
                    <Divider orientation='left'/>
                    <Form.Item
                        style={formStyle}
                        name='email'
                        label='Email'
                        rules={[
                            {
                                required: false,
                                type: 'string',
                                max: 100,
                                min: 1,
                                pattern: new RegExp(/^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,4}$/i),
                                message: "Email must be in a valid format"
                            }
                        ]}
                    >
                        <Input />
                    </Form.Item>
                    <Form.Item
                        style={formStyle}
                        name='secondary_email'
                        label='Secondary Email'
                        rules={[
                            {
                                required: false,
                                type: 'string',
                                max: 100,
                                min: 1,
                                pattern: new RegExp(/^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,4}$/i),
                                message: "Email must be in a valid format"
                            }
                        ]}
                    >
                        <Input />
                    </Form.Item>
                    <Form.Item
                        style={formStyle}
                        name='phone_number'
                        label='Phone Number'
                        rules={[
                            {
                                required: false,
                                type: 'string',
                                max: 100,
                                min: 1,
                                pattern: new RegExp(/^[0-9\b]+$/),
                                message: "Phone number must consist of digits"
                            }
                        ]}
                    >
                        <Input />
                    </Form.Item>
                    <Form.Item
                        style={formStyle}
                        name='website'
                        label='Website'
                        rules={[
                            {
                                required: false,
                                type: 'string',
                                max: 100,
                                min: 1,
                                pattern: new RegExp(/((([A-Za-z]{3,9}:(?:\/\/)?)(?:[-;:&=\+\$,\w]+@)?[A-Za-z0-9.-]+|(?:www.|[-;:&=\+\$,\w]+@)[A-Za-z0-9.-]+)((?:\/[\+~%\/.\w-_]*)?\??(?:[-\+=&;%@.\w_]*)#?(?:[\w]*))?)/),
                                message: "Website link must be a valid URL"
                            }
                        ]}
                    >
                        <Input />
                    </Form.Item>
                    <Divider orientation='left'/>
                    <Form.Item
                        style={formStyle}
                        name='address_line1'
                        label='Address Line 1'
                        rules={[
                            {
                                required: false,
                                type: 'string',
                                max: 100,
                                min: 1
                            }
                        ]}
                    >
                        <Input />
                    </Form.Item>
                    <Form.Item
                        style={formStyle}
                        name='address_line2'
                        label='Address Line 2'
                        rules={[
                            {
                                required: false,
                                type: 'string',
                                max: 100,
                                min: 1
                            }
                        ]}
                    >
                        <Input />
                    </Form.Item>
                    <Form.Item
                        style={formStyle}
                        name='city'
                        label='City'
                        rules={[
                            {
                                required: false,
                                type: 'string',
                                max: 100,
                                min: 1
                            }
                        ]}
                    >
                        <Input />
                    </Form.Item>
                    <Form.Item
                        style={formStyle}
                        name='state'
                        label='State'
                        rules={[
                            {
                                required: false,
                            }
                        ]}
                    >
                        <StateDropdown
                            onChange={(val) => {
                                if (!val)
                                    return
                                this.setState({
                                    stateVal: val[0]
                                })
                            }}
                        />
                    </Form.Item>
                    <Form.Item
                        style={formStyle}
                        name='zipcode'
                        label='Zipcode'
                        rules={[
                            {
                                required: false,
                                type: 'string',
                                max: 100,
                                min: 1,
                                pattern: new RegExp(/^[0-9\b]+$/),
                                message: "Zipcode must consist of digits"
                            }
                        ]}
                    >
                        <Input />
                    </Form.Item>
                    <Form.Item
                        style={formStyle}
                        name='country'
                        label='Country'
                        rules={[
                            {
                                required: false,
                                type: 'string',
                                max: 100,
                                min: 1
                            }
                        ]}
                    >
                        <Input />
                    </Form.Item>
                    <Divider orientation='left'/>
                    <Form.Item
                        style={formStyle}
                        name='source'
                        label='Sources'
                        hidden={true}
                        rules={[
                            {
                                required: false,
                                type: 'string',
                                max: 100,
                                min: 1
                            }
                        ]}
                    >
                        <Input placeholder='Enter as a comma separated list'/>
                    </Form.Item>
                    <Space direction="vertical" size="small" style={{ width: '100%', paddingBottom: '10px' }}>
                        <Row style={{gap: 12}}>
                            <Col xs={6} sm={4}>
                                <Space direction="horizontal" style={{ width: '100%', height: '100%', justifyContent: 'flex-end', paddingRight: '15px', paddingLeft: '15px' }}>
                                    <Text style={{ paddingRight: '10px' }}>Sources</Text>
                                </Space>
                            </Col>
                            <Col xs={24} sm={14} style={formStyle} offset={1}>
                                <Input
                                    placeholder="Type in a source and press enter"
                                    allowClear
                                    value={this.state.sourceValue}
                                    onChange={this.sourceHandleInputChange}
                                    onPressEnter={this.sourceHandleInputConfirm}
                                />
                            </Col>
                        </Row>
                        <Row>
                            <Col span={6}>
                            </Col>
                            <Col span={14}>
                                {this.loadSources()}
                            </Col>
                        </Row>
                    </Space>
                    <Form.Item
                        name='tags'
                        label='Tags'
                        hidden={true}
                        rules={[
                            {
                                required: false,
                                type: 'string',
                                max: 1000,
                                min: 1
                            }
                        ]}
                    >
                        <Input placeholder="Enter as a comma separated list"/>
                    </Form.Item>
                    <Space direction="vertical" size="small" style={{ width:'100%', paddingBottom: '10px' }}>
                        <Row style={{gap: 12}}>
                            <Col xs={4} sm={4}>
                                <Space direction="horizontal" style={{ width: '100%', height: '100%', justifyContent: 'flex-end', paddingRight: '15px', paddingLeft: '15px' }}>
                                    <Text style={{ paddingRight: '10px' }}>Tags</Text>
                                </Space>
                            </Col>
                            <Col xs={24} sm={14} style={formStyle} offset={1}>
                                <Input
                                    placeholder="Type in a tag and press enter"
                                    allowClear
                                    value={this.state.inputValue}
                                    onChange={this.handleInputChange}
                                    onPressEnter={this.handleInputConfirm}
                                />
                            </Col>
                        </Row>
                        <Row>
                            <Col span={6}>
                            </Col>
                            <Col span={14}>
                                {this.loadTags()}
                            </Col>
                        </Row>
                    </Space>
                    <Form.Item
                        style={formStyle}
                        name='notes'
                        label='Notes'
                        rules={[
                            {
                                required: false,
                                type: 'string',
                                max: 1000,
                                min: 1
                            }
                        ]}
                    >
                        <TextArea rows={3} />
                    </Form.Item>
                    <FormButton>
                        <Row style={{width: '100%', display: 'flex', maxWidth: 1200, flexDirection: 'row', justifyContent: 'space-evenly'}}>
                            <Col style={{width: '20%', minWidth: 160}}>
                                <Button block danger size='large' onClick={() => {
                                    if (this.is_new) {
                                        return this.props.history.push(URL_CONTACTS)
                                    } else {
                                        window.close()
                                    }
                                }}>
                                    Cancel
                                </Button>
                            </Col>
                            <Col style={{width: '20%', minWidth: 160, marginLeft: 'auto'}}>
                                <Button block icon={<ContactsOutlined />} type='primary' size='large' htmlType={'submit'}>
                                    {this.is_new ? 'Save' : 'Update'} Contact
                                </Button>
                            </Col>
                        </Row>
                    </FormButton>
                </Form >
            </Spin >
        )
    }
}

export default withRouter(NewContact)